function format(value) {
    return JSON.stringify(value, null, 4);
}
export const json = {
    format,
};
